module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_VIRTUAL_1_B-6ef0f22c91ad11ba7a1b0b567d5d0a5a.gif";